exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-wrapper-company .form-company-details {\n  margin-bottom: .25rem;\n  color: #333;\n}\n.form-wrapper-company .form-company-details.searched {\n  margin-top: .5rem;\n  padding: .75rem;\n  border-width: 1px;\n  border-style: dashed;\n}\n.form-wrapper-company .form-company-details p {\n  margin-bottom: .25rem;\n}\n.form-wrapper-company .form-company-details p:last-child {\n  margin-bottom: 0;\n}\n.form-wrapper-company .form-company-error {\n  width: 100%;\n  font-size: .75rem;\n  margin-bottom: 0;\n  margin-top: .5rem;\n  font-style: italic;\n  color: #dc2626;\n}\n", ""]);

// exports
